module.exports = __webpack_public_path__ + "static/media/candy-nav-clr-sqrTiny.f5883eb8.png";